import red from "@material-ui/core/colors/red";
import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    background: "#FFF",
    minHeight: "100vh",
    height: "100%",
  },
  appbar: {
    background: "#FFF",
    boxShadow: "0em 0em 1.5625rem rgba(0, 0, 0, 0.1)",
    height: "70px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
  },
  toolbar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    "& svg": {
      boxSizing: "content-box",
      padding: "10px 25px",
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 600,
    marginBlock: 15,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    paddingBottom: 20,
  },
  top: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  bottom: {
    width: "100%", // Fix IE 11 issue.
    marginBottom: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  errorMessage: {
    color: red[500],
  },
  formWrapper: {
    width: "100%",
    maxWidth: 520,
    padding: "0 40px",
  },
  content: {
    background: "#FFF",
    height: "100%",
    minHeight: "100%",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    margin: "70px auto 0px",
    flexFlow: "column nowrap",
    "& .MuiTypography-root": {
      fontFamily: "Inter",
    },
  },
  wrapper: {
    height: "100%",
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center",
    marginBlockStart: "70px",
    fontFamily: "Inter",
  },
  wrapperContainer: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "flex-start",
    alignContent: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  logo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 45,
    marginTop: 85,
    width: "100%",
    maxWidth: 276,
    [theme.breakpoints.down("sm")]: {
      marginTop: 14,
      width: "80%",
      marginBottom: 27,
    },
  },
  character1: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: 80,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  character2: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: 55,
    marginBottom: 3,
    [theme.breakpoints.down("sm")]: {
      maxWidth: 25,
      width: "20%",
    },
  },
  loginLeftContent: {
    height: "100vh",
    display: "flex",
    alignItems: "flex-start",
    alignContent: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      width: "100%",
      height: "100%",
    },
  },
  testimonialsContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: -100,
    },
  },
  loginRightContent: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      width: "100%",
      height: "100%",
    },
  },
  total: {
    textAlign: "end",
    backgroundColor: "#ffffff!important",
    "&.MuiInputBase-input.Mui-disabled": {
      color: "#4187b6!important",
      fontSize: 20,
      fontWeight: "bold",
    },
  },
  normal: {
    backgroundColor: "#ffffff!important",
    "&.MuiInputBase-input.Mui-disabled": {
      fontSize: 20,
    },
  },
  subtotal: {
    textAlign: "end !important" as "end",
    backgroundColor: "#ffffff!important",
  },
  sum: { marginBottom: 0, marginTop: 5 },
  policy: {
    fontSize: "small",
    color: "#b6b4b4de",
  },
  label: {
    fontSize: "16px",
    color: "#0000008a",
    padding: 0,
    fontWeight: 400,
    marginBottom: theme.spacing(1),
  },
  drop: {
    "&.MuiFormLabel-root": {
      fontSize: "10px!important",
    },
  },
  center: {
    textAlign: "center",
  },
  blue: {
    color: "#6199BE",
  },
  green: {
    fontStyle: "italic",
    color: "#36985E",
  },
  labelColor: {
    color: "#6199BE",
  },
  spans: {
    fontSize: "11px",
  },
  walletButton: {
    color: "#fafafa",
    backgroundColor: "#02081d",
    backgroundHoverColor: "#46474a",
  },
  freeTrialDetailsContainer: {
    marginTop: "-16px",
  },
  freeTrialDetails: {
    textAlign: "center",
    textDecoration: "underline",
    color: "#4187B6",
    fontWeight: "bold",
  },
  footer: {
    background: "#FFF",
    bottom: "0",
    right: "0",
    left: "0",
    zIndex: 2,
  },
  emailLink: {
    fontFamily: "Lato",
    textDecoration: "none",
    color: "#666666",
    fontSize: theme.typography.pxToRem(14),
    padding: "5px",
    fontWeight: 500,
    "&:hover": {
      color: "#4187B6",
      cursor: "pointer",
    },
  },
}));
